// AI API Service
// This service handles AI conversation requests

// Auto-detect API URL based on current host (called at runtime)
const getApiBaseUrl = () => {
  // Allow explicit override via environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current host (runtime check)
  if (typeof window === 'undefined') {
    // Server-side rendering fallback
    return '/api/v1';
  }
  
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Development: use localhost API server
    return 'http://localhost:3001/api/v1';
  } else if (hostname.includes('aidrivenlabs.xyz') || hostname.includes('aidrivenlabs.web.app')) {
    // Production: use same domain for API
    return `${window.location.protocol}//${hostname}/api/v1`;
  } else {
    // Fallback: use same origin
    return `${window.location.origin}/api/v1`;
  }
};

export const chatWithAI = async (appletId, messages, options = {}) => {
  try {
    const API_BASE_URL = getApiBaseUrl();
    const response = await fetch(`${API_BASE_URL}/ai/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        appletId,
        messages,
        userEmail: options.userEmail || null,
        ...options
      })
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling AI API:', error);
    throw error;
  }
};

export const getAvailableModels = async () => {
  try {
    const API_BASE_URL = getApiBaseUrl();
    const response = await fetch(`${API_BASE_URL}/ai/models`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching models:', error);
    throw error;
  }
};

